import React, { useState } from "react";
import DealsTable from "./details";
import VerifyVatModal from "./VerifyVatModal";
import NewDealModal from "./NewDealModal";
import DealsNotificationBell from "./DealsNotificationBell";
import { Deal } from "./api";
import { useT } from "../../i18n";

const DealsPage: React.FC = () => {
  const t = useT();
  const [vatModalOpen, setVatModalOpen] = useState(false);
  const [newDealOpen, setNewDealOpen] = useState(false);
  const [editDeal, setEditDeal] = useState<Deal | null>(null);
  const [snackbar, setSnackbar] = useState<string | null>(null);

  const handleDealSuccess = () => {
    setSnackbar(
      editDeal ? t("deals.toast.updated") : t("deals.toast.created")
    );
    setTimeout(() => setSnackbar(null), 3000);
  };

  const handleEditDeal = (deal: Deal) => {
    setEditDeal(deal);
    setNewDealOpen(true);
  };

  const handleCloseModal = () => {
    setNewDealOpen(false);
    setEditDeal(null);
  };

  return (
    <div className="flex flex-col flex-1 min-h-screen bg-gray-50 w-full h-full p-0 m-0">
      <header className="flex items-center justify-between h-20 px-8 bg-white border-b border-gray-200 w-full">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">{t("deals.title")}</h2>
          <p className="text-sm text-gray-500">
            {t("deals.subtitle")}
          </p>
        </div>
        <div className="flex items-center space-x-4">
          <button
            className="px-5 py-2.5 flex items-center bg-[#111827] text-white rounded-lg hover:bg-gray-800 transition-colors text-sm font-medium shadow-sm"
            onClick={() => setNewDealOpen(true)}
          >
            <i className="fa-solid fa-plus mr-2"></i> {t("deals.newDeal")}
          </button>
          <button
            className="px-5 py-2.5 flex items-center bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium shadow-sm"
            onClick={() => setVatModalOpen(true)}
          >
            <i className="fa-solid fa-shield-check mr-2"></i> {t("deals.verifyVat")}
          </button>
          <div className="flex items-center space-x-4 pl-2">
            <DealsNotificationBell />
          </div>
        </div>
      </header>
      <main className="flex-1 p-8 w-full h-full flex flex-col">
        <div className="flex-1 flex flex-col">
          <DealsTable onEditDeal={handleEditDeal} />
        </div>
      </main>
      <VerifyVatModal
        open={vatModalOpen}
        onClose={() => setVatModalOpen(false)}
      />
      <NewDealModal
        open={newDealOpen}
        onClose={handleCloseModal}
        onSuccess={handleDealSuccess}
        editDeal={editDeal}
      />
      {snackbar && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-teal-600 text-white px-6 py-3 rounded-lg shadow-lg z-50 font-medium animate-fade-in">
          {snackbar}
        </div>
      )}
    </div>
  );
};

export default DealsPage;
